import { Prop, Schema, SchemaFactory } from '@nestjs/mongoose';
import { Document } from 'mongoose';

export type UserDocument = User & Document;

export enum UserRole {
  ADMIN = 'admin',
  CUSTOMER = 'customer',
}

@Schema()
export class Address {
  @Prop({ required: false })
  address?: string;

  @Prop({ required: false })
  city?: string;

  @Prop({ required: false })
  state?: string;

  @Prop({ required: false })
  zipCode?: string;

  @Prop({ required: false })
  country?: string;

  @Prop({ default: false })
  isDefault?: boolean;
}

@Schema({ timestamps: true })
export class User {
  @Prop({ required: true })
  name: string;

  @Prop({ required: true, unique: true })
  email: string;

  @Prop({ required: true })
  password: string;

  @Prop({ type: String, enum: UserRole, default: UserRole.CUSTOMER })
  role: UserRole;

  @Prop({ type: [Address], default: [], required: false })
  addresses?: Address[];

  @Prop({ default: true })
  isActive: boolean;

  @Prop()
  lastLogin: Date;

  @Prop({ required: false })
  phone?: string;

  @Prop({ required: false })
  avatar?: string;

  @Prop({ required: false, type: Object, default: {} })
  preferences?: {
    language?: string;
    timezone?: string;
    notifications?: boolean;
  };

}

export const UserSchema = SchemaFactory.createForClass(User);

// Index for better performance (only role since email is already indexed by unique: true)
UserSchema.index({ role: 1 });

